/* tslint:disable */
/* eslint-disable */
/**
 * Carrot Config Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The "FilterTimeFrameValue" Enum
 * @export
 */
export const FilterTimeFrameValue = {
    Today: 'TODAY',
    Yesterday: 'YESTERDAY',
    YearToDate: 'YEAR_TO_DATE',
    Last30Days: 'LAST_30_DAYS',
    Last90Days: 'LAST_90_DAYS',
    LastWeek: 'LAST_WEEK',
    LastMonth: 'LAST_MONTH',
    LastYear: 'LAST_YEAR',
    Last3Months: 'LAST_3_MONTHS',
    Last6Months: 'LAST_6_MONTHS',
    Last12Months: 'LAST_12_MONTHS',
    Last6FullMonths: 'LAST_6_FULL_MONTHS',
    LastFullYear: 'LAST_FULL_YEAR',
    SinceBeginning: 'SINCE_BEGINNING',
    ThisMonth: 'THIS_MONTH',
    ThisQuarter: 'THIS_QUARTER',
    PrevQuarter: 'PREV_QUARTER'
};
export function instanceOfFilterTimeFrameValue(value) {
    for (const key in FilterTimeFrameValue) {
        if (Object.prototype.hasOwnProperty.call(FilterTimeFrameValue, key)) {
            if (FilterTimeFrameValue[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FilterTimeFrameValueFromJSON(json) {
    return FilterTimeFrameValueFromJSONTyped(json, false);
}
export function FilterTimeFrameValueFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FilterTimeFrameValueToJSON(value) {
    return value;
}
//# sourceMappingURL=FilterTimeFrameValue.js.map